<template>
  <div>
    <!-- Container-fluid starts-->
    <div
      v-if="showDashboard===0"
      class="container"
    >
      <div class="page-header">
        <div class="page-header-left">
          <ol class="breadcrumb ml-0">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'welcome' }">
                <feather type="home" />
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'companyProfile' }">
                {{ $t('changeAccount.irktProfili') }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              {{ $t('dashboardCompany.irktLvhsi') }}
            </li>
          </ol>
        </div>
        <h3 class="mt-3">
          {{ $t('dashboardCompany.irktLvhsi') }}
        </h3>
      </div>

      <div class="row">
        <div
          v-if="company"
          class="col-lg-8"
        >
          <div class="card">
            <div class="card-body">
              <template v-for="(a,i) in actions">
                <div
                  :key="i"
                  class="d-flex justify-content-start align-items-center my-2"
                >
                  <img
                    class="rounded-circle"
                    :src="getPhoto(a.user.photo,'thumbnailCropped')"
                    alt=""
                    style="width: 50px;"
                  >

                  <div class="ml-3">
                    <strong>
                      {{ a.user.name }} {{ a.user.surname }}
                    </strong>
                    {{ actionLocalization(a.action) }}

                    <br>
                    <div class="text-secondary">
                      {{ getMoment(a.logTime) }}
                    </div>
                  </div>
                </div>
                <hr>
              </template>
            </div>
          </div>
        </div>

        <div
          v-if="company"
          class="col-lg-4"
        >
          <div class="user-cards">
            <div class="card custom-card">
              <div class="card-header">
                <img
                  class="img-fluid bg-primary"
                  src="../../../assets/images/nophoto.jpg"
                  alt=""
                >
              </div>
              <div class="card-profile">
                <img
                  class="rounded-circle"
                  :src="getPhoto(company.logo,'mediumCropped')"
                  alt=""
                >
              </div>

              <div class="text-center profile-details">
                <h4>
                  {{ company.name }}
                  {{ getCompanyFormat(company.format) }}
                </h4>
                <h5>
                  <strong>{{ company.taxId }}</strong>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="row"
    >
      <div class="col-sm-12 p-0">
        <div class="auth-innerright">
          <div class="authentication-box" />
          <div class="card mt-4 p-4">
            <div
              class="alert alert-primary text-center my-4"
              style="padding: 50px 20px;"
            >
              <feather
                type="clock"
                size="40"
              />
              <br>
              <span v-if="showDashboard===1">
                {{
                  $t('dashboardVue.sizinBuIrktQoulmanzNIrktinizinAdminiTrfindnTsdiqln', {
                    adminName: company.adminName,
                    adminSurname: company.adminSurname
                  })
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  getCompanyBoard, userAccounts
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";
import {actionLocalization, getCompanyFormat, getPhoto, getProfileName} from "/src/repositories/Utils";
import moment from "moment/moment";


export default {
  data() {
    return {
      mediaBase: mediaBase,
      showDashboard: 0,
      actions: []
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
    }),
  },
  mounted() {
    this.userAccount();
    this.timer = setInterval(() => {
      this.userAccount();
    }, 5000)
    this.getCompanyBoard();

  },
  methods: {
    userAccount() {

      userAccounts(this.token).then(data => {
        this.profiles = data;this.profiles = data;
        let ae = data.filter(profile => {
          return profile.company.id === this.company.id && profile.profileType === this.profile;
        });

        if (ae.length > 0 && this.company.adminName) {
          this.showDashboard = (ae[0].status === "verified") ? 0 : 1;
        }
        if (this.showDashboard === 0) {
          clearInterval(this.timer);
        }
        // this.showDashboard = (this.company.status === "VERIFIED" || this.company.status==="CONFIRMED") ? 0 : 2;
      });
    },

    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getCompanyBoard() {
      getCompanyBoard(this.token).then(data => {
        if (data.code === 200) {
          this.actions = data.data;
        }
      })
    },
    actionLocalization(action) {
      return actionLocalization(action);
    }
  }


}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
